import { attachHlsIfNeeded } from '../html5video/hls_loader'

if (layData.thumbnail_video_and_mouseover_image_behavior == 'video' && layData.thumbnail_mouseover_image == 'on') {
	// were showing video on mouseover. so i will make it go back to the start of the video on mouseenter
	jQuery(document).on('mouseenter', '.thumb', function (event) {
		var $video = jQuery(event.currentTarget).find('video')
		var $img = jQuery(event.currentTarget).find('img')
		if ($video.length > 0 && $img.length > 0) {
			$video[0].currentTime = 0
		}
	})
}

// Lazy-load video thumbnails on first mouseenter.
// Renders the project image initially; the <video data-mp4 preload="none">
// has no <source> until the user hovers. On mouseenter we inject the source,
// kick off load+play, and fade the image out the moment `playing` fires
// (not earlier — otherwise the thumb flashes empty while the video buffers).
;(function () {
	var PLAYING_CLASS = 'lay-thumb-video-lazy-mouseover--playing'

	var attachPlayingListener = function (video) {
		if (video._layPlayingBound) return
		video._layPlayingBound = true
		var onPlaying = function () {
			video.classList.add(PLAYING_CLASS)
		}
		video.addEventListener('playing', onPlaying)
	}

	var ensureSource = function (video) {
		if (video.querySelector('source')) return
		var mp4 = video.getAttribute('data-mp4')
		if (!mp4) return
		var type = video.getAttribute('data-type') || 'video/mp4'
		var source = document.createElement('source')
		source.setAttribute('src', mp4)
		source.setAttribute('type', type)
		video.appendChild(source)
		attachHlsIfNeeded(video)
		try {
			video.load()
		} catch (e) {}
	}

	jQuery(document).on('mouseenter', '.thumb.has-lazy-video-thumb', function (event) {
		var video = event.currentTarget.querySelector('video.lay-thumb-video-lazy-mouseover')
		if (!video) return
		attachPlayingListener(video)
		ensureSource(video)
		try {
			video.currentTime = 0
		} catch (e) {}
		var p = video.play()
		if (p && typeof p.then === 'function') {
			p.catch(function () {})
		}
	})

	jQuery(document).on('mouseleave', '.thumb.has-lazy-video-thumb', function (event) {
		var video = event.currentTarget.querySelector('video.lay-thumb-video-lazy-mouseover')
		if (!video) return
		video.classList.remove(PLAYING_CLASS)
		try {
			video.pause()
		} catch (e) {}
	})
})()

// project title follows mouse on non touch devices
if (layData.pt_follow_mouse == '1' && jQuery('body').hasClass('no-touchdevice')) {
	var $title
	var $followMouseTitle
	var $followMouseLayer
	var offset = 10
	var projectOverlayOpening = false
	var activeThumbnailWrap = null
	var hasMousePosition = false
	var mouseClientX = 0
	var mouseClientY = 0
	var scrollHoverRaf = null
	var scrollSliderHoverRaf = null
	var scrollSliderHoverFrames = 0
	var floatRaf = null
	var floatState = {
		initialized: false,
		target: { x: 0, y: 0 },
		current: { x: 0, y: 0 },
		lastTime: 0,
	}
	var followMouseFloatIsEnabled = function () {
		var value = layData.pt_follow_mouse_float
		return value === true || value == 'on' || value == '1' || value == 1 || value == 'true'
	}
	var scrollSliderIsActive = function () {
		return document.documentElement.classList.contains('scrollslider-active') || document.documentElement.classList.contains('infinite-scrollslider-active')
	}
	var getNow = function () {
		return window.performance && typeof window.performance.now == 'function' ? window.performance.now() : new Date().getTime()
	}
	var resetFloat = function () {
		if (floatRaf != null) {
			window.cancelAnimationFrame(floatRaf)
			floatRaf = null
		}
		floatState.initialized = false
		floatState.target.x = 0
		floatState.target.y = 0
		floatState.current.x = 0
		floatState.current.y = 0
		floatState.lastTime = 0
	}
	var renderFloatPosition = function () {
		if ($followMouseTitle && $followMouseTitle.length) {
			$followMouseTitle.css('transform', 'translate(' + floatState.current.x + 'px,' + floatState.current.y + 'px)')
		}
	}
	var tickFloat = function () {
		floatRaf = null
		if (!$followMouseTitle || !$followMouseTitle.length) {
			return
		}

		var stiffness = 0.45
		var damping = 0.72
		var now = getNow()
		var dt = floatState.lastTime ? Math.min(64, Math.max(8, now - floatState.lastTime)) : 16.6667
		floatState.lastTime = now

		var followAmount = Math.max(0.02, Math.min(0.6, stiffness * (1 - damping)))
		var normalizedFollowAmount = 1 - Math.pow(1 - followAmount, dt / 16.6667)
		var dx = floatState.target.x - floatState.current.x
		var dy = floatState.target.y - floatState.current.y

		floatState.current.x += dx * normalizedFollowAmount
		floatState.current.y += dy * normalizedFollowAmount
		renderFloatPosition()

		if (Math.abs(dx) < 0.1 && Math.abs(dy) < 0.1) {
			floatState.current.x = floatState.target.x
			floatState.current.y = floatState.target.y
			renderFloatPosition()
			return
		}

		floatRaf = window.requestAnimationFrame(tickFloat)
	}
	var setFloatTarget = function (x, y) {
		if (!$followMouseTitle || !$followMouseTitle.length) {
			return
		}
		if (!floatState.initialized) {
			floatState.initialized = true
			floatState.target.x = x
			floatState.target.y = y
			floatState.current.x = x
			floatState.current.y = y
			floatState.lastTime = 0
			renderFloatPosition()
			return
		}
		floatState.target.x = x
		floatState.target.y = y
		if (floatRaf == null) {
			floatRaf = window.requestAnimationFrame(tickFloat)
		}
	}
	var setFollowMouseTitlePosition = function (x, y) {
		if (followMouseFloatIsEnabled()) {
			setFloatTarget(x, y)
			return
		}
		resetFloat()
		if ($followMouseTitle && $followMouseTitle.length) {
			$followMouseTitle.css('transform', 'translate(' + x + 'px,' + y + 'px)')
		}
	}
	var getLayerParent = function (thumbnailWrap) {
		var projectOverlay = thumbnailWrap.closest('#lay-project-overlay')
		if (projectOverlay) {
			return projectOverlay
		}

		var pageOverlay = thumbnailWrap.closest('.lay-overlay')
		if (pageOverlay) {
			return pageOverlay
		}

		return document.body
	}
	var getLayer = function (thumbnailWrap) {
		var parent = getLayerParent(thumbnailWrap)
		var $parent = jQuery(parent)
		var $layer = $parent.children('.lay-project-title-follow-mouse-layer')
		if ($layer.length == 0) {
			$layer = jQuery('<div class="lay-project-title-follow-mouse-layer"></div>')
			$parent.append($layer)
		}
		return $layer
	}
	var shouldSuppressForProjectOverlay = function (thumbnailWrap) {
		if (thumbnailWrap.closest('#lay-project-overlay')) {
			return false
		}

		return (
			projectOverlayOpening ||
			document.documentElement.classList.contains('show-project-overlay') ||
			document.documentElement.classList.contains('project-overlay-transitioning')
		)
	}
	var setMousePositionFromEvent = function (e) {
		if (!e) {
			return
		}
		mouseClientX = e.clientX
		mouseClientY = e.clientY
		hasMousePosition = true
	}
	var hideFollowMouseTitle = function () {
		if ($followMouseTitle && $followMouseTitle.length) {
			$followMouseTitle.remove()
		}
		jQuery('.lay-project-title-follow-mouse-title').remove()
		$followMouseTitle = null
		activeThumbnailWrap = null
		resetFloat()
	}
	var moveFollowMouseTitle = function () {
		if (!hasMousePosition) {
			return
		}
		setFollowMouseTitlePosition(mouseClientX + offset, mouseClientY + offset)
	}
	var showFollowMouseTitleForThumbnailWrap = function (thumbnailWrap) {
		if (!thumbnailWrap || shouldSuppressForProjectOverlay(thumbnailWrap)) {
			hideFollowMouseTitle()
			return
		}

		if (activeThumbnailWrap === thumbnailWrap && $followMouseTitle && $followMouseTitle.length) {
			moveFollowMouseTitle()
			return
		}

		hideFollowMouseTitle()
		$title = jQuery(thumbnailWrap).find('.title')
		if ($title.length == 0) {
			return
		}

		activeThumbnailWrap = thumbnailWrap
		$followMouseLayer = getLayer(thumbnailWrap)
		$followMouseTitle = $title.first().clone()
		$followMouseTitle.removeAttr('id')
		$followMouseTitle.removeAttr('style')
		$followMouseTitle.addClass('lay-project-title-follow-mouse-title')
		$followMouseLayer.append($followMouseTitle)
		moveFollowMouseTitle()
	}
	var getThumbnailWrapFromPointer = function () {
		if (!hasMousePosition) {
			return null
		}
		var el = document.elementFromPoint(mouseClientX, mouseClientY)
		return el && el.closest ? el.closest('.thumbnail-wrap') : null
	}
	var updateFollowMouseTitleFromPointer = function () {
		scrollHoverRaf = null
		var thumbnailWrap = getThumbnailWrapFromPointer()
		if (!thumbnailWrap) {
			hideFollowMouseTitle()
			return
		}
		showFollowMouseTitleForThumbnailWrap(thumbnailWrap)
	}
	var scheduleFollowMouseTitleFromPointerUpdate = function () {
		if (scrollHoverRaf != null) {
			return
		}
		scrollHoverRaf = window.requestAnimationFrame(updateFollowMouseTitleFromPointer)
	}
	var scrollSliderHoverLoop = function () {
		scrollSliderHoverRaf = null
		if (!hasMousePosition || !scrollSliderIsActive() || scrollSliderHoverFrames <= 0) {
			return
		}

		scheduleFollowMouseTitleFromPointerUpdate()
		scrollSliderHoverFrames--
		scrollSliderHoverRaf = window.requestAnimationFrame(scrollSliderHoverLoop)
	}
	var startScrollSliderHoverLoop = function () {
		scrollSliderHoverFrames = Math.max(scrollSliderHoverFrames, 90)
		if (scrollSliderHoverRaf != null) {
			return
		}
		scrollSliderHoverRaf = window.requestAnimationFrame(scrollSliderHoverLoop)
	}

	jQuery(document).on('mouseenter', '.thumbnail-wrap', function (e) {
		setMousePositionFromEvent(e)
		showFollowMouseTitleForThumbnailWrap(e.currentTarget)
	})
	jQuery(document).on('mouseleave', '.thumbnail-wrap', function () {
		hideFollowMouseTitle()
	})
	jQuery(document).on('click', '.thumbnail-wrap', function () {
		if (layData.projects_overlays == 'on') {
			projectOverlayOpening = true
		}
		hideFollowMouseTitle()
	})

	jQuery(document).on('mousemove', '.thumbnail-wrap', function (e) {
		setMousePositionFromEvent(e)
		showFollowMouseTitleForThumbnailWrap(e.currentTarget)
	})
	jQuery(document).on('mousemove', function (e) {
		setMousePositionFromEvent(e)
		if (scrollSliderIsActive()) {
			startScrollSliderHoverLoop()
		}
	})
	jQuery(document).on('wheel.layProjectTitleFollowMouse touchmove.layProjectTitleFollowMouse keydown.layProjectTitleFollowMouse', function () {
		if (scrollSliderIsActive()) {
			startScrollSliderHoverLoop()
		}
	})

	if (window.laytheme && typeof window.laytheme.on == 'function') {
		window.laytheme.on('project_overlay_before_animate_in', function () {
			projectOverlayOpening = true
			hideFollowMouseTitle()
		})
		window.laytheme.on('project_overlay_open_start', function () {
			projectOverlayOpening = true
			hideFollowMouseTitle()
		})
		window.laytheme.on('project_overlay_open_end', function () {
			projectOverlayOpening = false
			hideFollowMouseTitle()
		})
		window.laytheme.on('projectoverlayclosed', function () {
			projectOverlayOpening = false
			hideFollowMouseTitle()
		})
		window.laytheme.on('destroyoverlay', function () {
			projectOverlayOpening = false
			hideFollowMouseTitle()
		})
		window.laytheme.on('scrollslider-initialized', startScrollSliderHoverLoop)
	}

	if (window.eventsChannel && window.eventsChannel.on && window.eventsChannel.off) {
		window.eventsChannel.off('scroll', scheduleFollowMouseTitleFromPointerUpdate)
		window.eventsChannel.on('scroll', scheduleFollowMouseTitleFromPointerUpdate)
	}

	jQuery('.lay-overlay>.lay-content').off('scroll.layProjectTitleFollowMouse').on('scroll.layProjectTitleFollowMouse', scheduleFollowMouseTitleFromPointerUpdate)
}
